<template>
  <div style="color: black;">
    <!-- Monta Layout Refrigeração -->
    <div
      style="text-align: center; position: relative; font-size: 30px"
      v-if="loading == true"
    >
      <i class="fas fa-spinner fa-spin"></i> Carregando
    </div>
    <div v-if="!isSolar">
      <vue-html2pdf
        :show-layout="true"
        :float-layout="false"
        :enable-download="false"
        :preview-modal="true"
        :paginate-elements-by-height="1000"
        filename="PedidoLeveros"
        :pdf-quality="2"
        :manual-pagination="false"
        pdf-format="a4"
        pdf-orientation="portrait"
        pdf-content-width="800px"
        ref="html2Pdf"
      >
        <section
          slot="pdf-content"
          class="impressao"
          v-for="(infos, i) in infos"
          :key="i"
        >
          <div class="header">
            <div class="header__logo">
              <img :src="logoPedido" alt="" style="height: 80px" />
            </div>

            <div class="header__pedidoCD">
              <div class="header__pedidoCD--pedido">
                <p><span>Pedido:</span> {{ infos.NRPedido }}</p>
                <p>
                  <span>Data:</span>
                  {{ moment(infos.dtPedido).format("DD/MM/YYYY") }}
                </p>
              </div>
              <div class="header__pedidoCD--cd">
                <p>REFRIGELO CLIMATIZAÇÃO DE AMBIENTES S/A</p>
                <p><span>CD Conde - PB:</span> 61.502.324/0019-41</p>
                <p><span>CD Blumenau - SC:</span> 21.795.351/0001-06</p>
                <p><span>CD Vila Velha - ES:</span> 61.502.324/0021-66</p>
              </div>
            </div>

            <div class="header__infosVendedor">
              <p><span>Código Atendente:</span> {{ infos.vendedor }}</p>
              <p><span>Nome:</span> {{ infos.NmVendedor }}</p>
              <p><span>E-mail:</span> {{ infos.EmailVendedor }}</p>
              <p v-if="infos.parceiro != ''">
                <span>Parceiro:</span> {{ infos.parceiro }}
              </p>
              <p v-if="infos.NMParceiro != null">
                <span>Nome:</span> {{ infos.NMParceiro }}
              </p>
            </div>
          </div>

          <div class="infosCliente">
            <div class="infosCliente__dadosPessoais">
              <p>
                <span>Cliente:</span> {{ infos.dadosCliente.nmcliente_razao }}
              </p>
              <p><span>CNPJ/CPF:</span> {{ infos.dadosCliente.cpfcnpj }}</p>
              <p
                v-if="
                  infos.dadosCliente.rg != null ||
                  infos.dadosCliente.inscricao != null
                "
              >
                <span>RG/IE:</span> {{ infos.dadosCliente.rg }} /
                {{ infos.dadosCliente.inscricao }}
              </p>
              <p>
                <span>Telefone:</span> ({{ infos.telefone[0].DDD }})
                {{ infos.telefone[0].NRTelefone }}
              </p>
              <p><span>E-mail:</span> {{ infos.dadosCliente.email }}</p>

              <hr />
              
              <p v-if="infos.itensPedido.length > 0">
                    <span>Prazo de entrega¹: </span>
                    <span v-if="!dataAgendada">
                      {{ infos.itensPedido[0].PrazoEntrega }} dias úteis
                    </span>
                    <span v-else>{{ moment(infos.PrevisaoEntrega).format("DD/MM/YYYY") }}
                    </span>
              </p>

              <div v-if="infos.frmPagamento.length > 0">
                <div class="" v-for="(pag, i) in infos.frmPagamento" :key="i">
                  <p>
                    <span>Cond. Pagamento²:</span>
                    {{ pag.dsformapgto }}
                    {{ pag.nrparcela }}x de
                    {{ (pag.vlTotal / pag.nrparcela) | toCurrency }}
                  </p>
                  <small>¹Sujeito à aprovação de crédito.</small>
                  <br />
                  <small>²Sujeito à disponibilidade de estoque.</small>
                </div>
              </div>
            </div>

            <div class="infosCliente__endereco">
              <p>
                <span>End. Faturamento:</span>
                {{ infos.dadosCliente.logradouro }}, Nº
                {{ infos.dadosCliente.nrresidencia }}
              </p>
              <p><span>Bairro:</span> {{ infos.dadosCliente.bairro }}</p>
              <p><span>CEP:</span> {{ infos.dadosCliente.cep }}</p>
              <p>
                <span>Cidade:</span> {{ infos.dadosCliente.cidade }}/{{
                  infos.dadosCliente.uf
                }}
              </p>
              <p><span>Comp:</span> {{ infos.dadosCliente.complemento }}</p>
              <hr />
              <p>
                <span>End. Entrega:</span>
                {{ infos.dadosCliente.enderecoentrega.logradouro }}, Nº
                {{ infos.dadosCliente.enderecoentrega.nrresidencia }}
              </p>
              <p>
                <span>Bairro:</span> {{ infos.dadosCliente.enderecoentrega.bairro }}
              </p>
              <p>
                <span>CEP:</span> {{ infos.dadosCliente.enderecoentrega.cep }}
              </p>
              <p>
                <span>Cidade:</span>
                {{ infos.dadosCliente.enderecoentrega.cidade }}/{{
                  infos.dadosCliente.enderecoentrega.uf
                }}
              </p>
              <p>
                <span>Comp:</span>
                {{ infos.dadosCliente.enderecoentrega.complemento }}
              </p>
            </div>
          </div>

          <div class="item" style="overflow-x: auto">
            <table>
              <thead>
                <tr>
                  <th>Cód. Item</th>
                  <th>Descrição do Produto</th>
                  <th>CD</th>
                  <th>Quantidade</th>
                  <th>Valor Unitário</th>
                  <th>Valor Total</th>
                </tr>
              </thead>
              <tbody>
                <tr v-for="(itens, ind) in itensPedido" :key="ind">
                  <td>{{ itens.sku }}</td>
                  <td style="text-align: left">
                    {{ itens.dsConjunto }}
                  </td>
                  <td>{{ itens.Expedicao }}</td>
                  <td>{{ itens.qtd }}</td>
                  <td>{{ (itens.VlBruto / itens.qtd) | toCurrency }}</td>
                  <td>{{ itens.VlBruto | toCurrency }}</td>
                </tr>
              </tbody>
            </table>
          </div>

          <div class="valoresTotais">
            <div class="garantiaCli">
              <!--<p><span>Prazo de Garantia³:</span></p>
              <p>
                <span>01 ano total:</span> Gree, LG, Agratto-Ventisol, Midea
                Convencional, Maxiflex Convencional, TCL
              </p>-->
              <!--<p><span>01 ano total / 06 anos no compressor:</span> Gree</p>-->
              <!--<p><span>1 ano total / 10 anos no compressor:</span> LG, Midea (Linha de Refrigeração)</p>-->
              <p>
                <span>02 anos total:</span> Maxiflex
              </p>
              <p>
                <!--<span>02 anos total / 05 anos no compressor:</span> Daikin (Linha Advance) e Fujitsu-->
              </p>
              <!--<p><span>2 anos total / 10 anos no compressor:</span> Daikin (Linha Exclusive)</p>-->
              <p><span>Demais marcas:</span> Conforme política do fabricante.</p>
              <small
                >³Garantia total válida desde que o equipamento seja instalado
                por uma empresa credenciada e operado de acordo com o manual do
                fabricante.
              </small>
              <p>
                <small
                  >⁴Exceto peças plásticas/volumes faltantes que a garantia é
                  valida até 30 dias após a emissão da NF de venda.</small
                >
              </p>
            </div>
            <div class="valoresTotais__valores">
              <p>
                <span>Valor dos Produtos:</span>
                {{ infos.vlBruto | toCurrency }}
              </p>
              <p>
                <span>Valor do Desconto:</span>
                {{ infos.vlDesconto | toCurrency }}
              </p>
              <p>
                <span>Valor do Frete:</span>
                {{ infos.vltotalfrete | toCurrency }}
              </p>
             
              <p>
                <span>Valor Total:</span>
                {{ (infos.vlliquido + infos.vltotalfrete) | toCurrency }}
              </p>
            </div>
          </div>

          <div class="pessoaJuridica">
            <p>
              <span>Imposto:</span> Nas operações interestaduais, o cliente
              (Pessoa Jurídica e contribuinte do ICMS) é responsável por
              observar a sua legislação estadual quanto às despesas com
              recolhimento antecipado do ICMS devido por substituição tributária
              e diferencial de aliquotas.
            </p>
            <p>
              <span
                >Obs.: Não trocamos produtos que já foram instalados ou fora da
                embalagem original.</span
              >
            </p>
          </div>

          <div class="complementaresAssinatura">
            <div class="complementaresAssinatura__nf">
              <p><span>Informações complementares (NF):</span></p>
              <p>{{ infos.observacao }}</p>
            </div>

            <div class="complementaresAssinatura__assinatura">
              <p>
                <span>Assinatura:</span>
                ____________________________________________
              </p>
              <p>
                <span>Nome: </span>
                _________________________________________________
              </p>
              <p>
                <span>CPF/CNPJ: </span>
                ______________________________________________
              </p>
              <p><span>Data:</span> _______ / _______ / ___________</p>
              <small
                >Aprovo o pedido e autorizo o fornecimento dos itens acima
                descriminados, ciente das minhas responsabiidades e condição de
                pagamento.</small
              >
            </div>
          </div>

          <div class="footer">
            <div class="footer__condicoes">
              <p>Condições de Fornecimento:</p>
              <ul>
                <li>
                  Sujeito a confirmação de dados cadastrais por telefone e
                  e-mail para garantir a segurança da compra.
                </li>
                <li>
                  Verifique seu produto no ato do recebimento. Em caso de
                  desacordo ou avaria, recuse a entrega.
                </li>
                <li>
                  Não efetuamos serviços de içamento ou contratação de andaimes.
                  A entrega das mercadorias será no endereço indicado na nota
                  fiscal de venda.
                </li>
                <li>
                  Consulte o manual do fabricante para orientações técnicas e de
                  consumo.
                </li>
                <li>
                  Execute as instalações e manutenções com os técnicos
                  credenciados do fabricante.
                </li>
                <li>
                  Antes de finalizar a compra, consulte a voltagem elétrica do
                  local de instalação do produto.
                </li>
                <li>
                  Em caso de troca ou cancelamento, seguimos o Código de Defesa
                  do consumidor.
                </li>
              </ul>
            </div>

            <div class="footer__reconhecimento">
              <p>Credibilidade e Reconhecimento:</p>
              <img src="../assets/reconhecimentos.png" alt="" />
            </div>
          </div>

          <div class="footerImagem">
            <img src="../assets/footer-leveros.png" alt="" />
          </div>
          <button onclick="window.print()">Salvar/Imprimir Pedido</button>
        </section>
      </vue-html2pdf>
    </div>
    <!-- Monta Layout Solar -->
    <div v-else>
      <vue-html2pdf
        :show-layout="true"
        :float-layout="false"
        :enable-download="false"
        :preview-modal="true"
        :paginate-elements-by-height="1000"
        filename="PedidoLeveros"
        :pdf-quality="2"
        :manual-pagination="false"
        pdf-format="a4"
        pdf-orientation="portrait"
        pdf-content-width="800px"
        ref="html2Pdf"
      >
        <section
          slot="pdf-content"
          class="impressao"
          v-for="(infos, i) in infos"
          :key="i"
        >
          <div class="header">
            <div class="header__logo">
              <img :src="logoPedido" alt="" style="height: 80px" />
            </div>

            <div class="header__pedidoCD">
              <div class="header__pedidoCD--pedido">
                <p><span>Pedido:</span> {{ infos.NRPedido }}</p>
                <p>
                  <span>Data:</span>
                  {{ moment(infos.dtPedido).format("DD/MM/YYYY") }}
                </p>
              </div>
              <div class="header__pedidoCD--cd">
                <p>REFRIGELO CLIMATIZAÇÃO DE AMBIENTES S/A</p>
                <p><span>CD Alhandra:</span> 61.502.324/0019-41</p>
                <p><span>CD Vila Velha:</span> 61.502.324/0021-66</p>
                <br />
              </div>
            </div>

            <div class="header__infosVendedor">
              <p v-if="infos.affiliateId">
                <span>Canal de Venda:</span>
                {{ infos.affiliateId.toUpperCase() }}
              </p>
              <p><span>Código Atendente:</span> {{ infos.vendedor }}</p>
              <p><span>Nome:</span> {{ infos.NmVendedor }}</p>
              <p><span>E-mail:</span> {{ infos.EmailVendedor }}</p>
              <p v-if="infos.parceiro != ''">
                <span>Parceiro:</span> {{ infos.parceiro }}
              </p>
              <p v-if="infos.NMParceiro != null">
                <span>Nome:</span> {{ infos.NMParceiro }}
              </p>
            </div>
          </div>

          <div class="infosCliente">
            <div class="infosCliente__dadosPessoais">
              <p>
                <span>Cliente:</span> {{ infos.dadosCliente.nmcliente_razao }}
              </p>
              <p><span>CNPJ/CPF:</span> {{ infos.dadosCliente.cpfcnpj }}</p>
              <p
                v-if="
                  infos.dadosCliente.rg != null ||
                  infos.dadosCliente.inscricao != null
                "
              >
                <span>RG/IE:</span> {{ infos.dadosCliente.rg }} /
                {{ infos.dadosCliente.inscricao }}
              </p>
              <p>
                <span>Telefone:</span> ({{ infos.telefone[0].DDD }})
                {{ infos.telefone[0].NRTelefone }}
              </p>
              <p><span>E-mail:</span> {{ infos.dadosCliente.email }}</p>
            </div>

            <div class="infosCliente__endereco">
              <p>
                <span>End. Faturamento:</span>
                {{ infos.dadosCliente.logradouro }}, Nº
                {{ infos.dadosCliente.nrresidencia }}
              </p>
              <p><span>CEP:</span> {{ infos.dadosCliente.cep }}</p>
              <p><span>Bairro:</span> {{ infos.dadosCliente.bairro }}</p>
              <p>
                <span>Cidade:</span> {{ infos.dadosCliente.cidade }}/{{
                  infos.dadosCliente.uf
                }}
              </p>
              <p><span>Comp:</span> {{ infos.dadosCliente.complemento }}</p>
              <hr />
              <p>
                <span>End. Entrega:</span>
                {{ infos.dadosCliente.enderecoentrega.logradouro }}, Nº
                {{ infos.dadosCliente.enderecoentrega.nrresidencia }}
              </p>
              <p>
                <span>Bairro:</span> {{ infos.dadosCliente.enderecoentrega.bairro }}
              </p>
              <p>
                <span>CEP:</span> {{ infos.dadosCliente.enderecoentrega.cep }}
              </p>
              <p>
                <span>Cidade:</span>
                {{ infos.dadosCliente.enderecoentrega.cidade }}/{{
                  infos.dadosCliente.enderecoentrega.uf
                }}
              </p>
              <p>
                <span>Comp:</span>
                {{ infos.dadosCliente.enderecoentrega.complemento }}
              </p>
            </div>
          </div>

          <div class="item" style="overflow-x: auto">
            <table>
              <thead>
                <tr>
                  <th>Cód. Item</th>
                  <th>Descrição do Produto</th>
                  <th>CD</th>
                  <th>Quantidade</th>
                  <th>Valor Unitário</th>
                  <th>Valor Total</th>
                </tr>
              </thead>
              <tbody>
                <tr v-for="(itens, ind) in infos.orderConfigs" :key="ind">
                  <td style="text-align: left">{{ itens.sku }}</td>
                  <td>
                    {{ itens.dsproduto }}
                  </td>
                  <td>{{ itens.deposito }}</td>
                  <td>{{ itens.quantidade }}</td>
                  <td>{{ (itens.yven / itens.quantidade) | toCurrency }}</td>
                  <td>{{ itens.yven | toCurrency }}</td>
                </tr>
              </tbody>
            </table>
          </div>

          <div class="valoresTotais" v-if="infos.frmPagamento.length != 0">
            <div
              class="valoresTotais__condicoes"
              v-for="(pag, i) in infos.frmPagamento"
              :key="i"
            >
              <p>
                <span>Cond. Pagamento²:</span>
                {{ pag.dsformapgto }}
                {{ pag.nrparcela }}x de
                {{ (pag.vlTotal / pag.nrparcela) | toCurrency }}
              </p>
              <p v-if="infos.itensPedido.length > 0">
                <span>Prazo de entrega³: </span>
                {{ infos.itensPedido[0].PrazoEntrega }} dias úteis
              </p>
              <hr />
              <small>¹Sujeito à aprovação de crédito.</small>
              <small>Sujeito à disponibilidade de estoque.</small>
            </div>
            <div class="valoresTotais__valores">
              <p>
                <span>Valor dos Produtos:</span>
                {{ infos.vlBruto | toCurrency }}
              </p>
              <p>
                <span>Valor do Desconto:</span>
                {{ infos.vlDesconto | toCurrency }}
              </p>
              <p>
                <span>Valor do Frete:</span>
                {{ infos.vltotalfrete | toCurrency }}
              </p>
              <p v-if="infos.PrevisaoEntrega">
                <span>Prazo de Entrega:</span>
                {{ moment(infos.PrevisaoEntrega).format("DD/MM/YYYY") }}
              </p>
              <p v-if="infos.itensPedido.length > 0">
                <span>Prazo de Entrega:</span>
                {{ infos.itensPedido[0].PrazoEntrega }}
              </p>
              <p>
                <span>Valor Total:</span>
                {{ infos.frmPagamento[0].vlTotal | toCurrency }}
              </p>
            </div>
          </div>

          <div
            class="valoresTotais"
            v-if="
              infos.frmPagamentoIncompleta.length != 0 &&
              infos.frmPagamento.length == 0
            "
          >
            <div
              class="valoresTotais__condicoes"
              v-for="(pag, i) in infos.frmPagamentoIncompleta"
              :key="i"
            >
              <p v-if="pag.cdFormapgto">
                <span>Cond. Pagamento²:</span>
                {{ pag.dsformapgto }}
              </p>
              <p v-if="infos.itensPedido.length > 0">
                <span>Prazo de entrega³: </span>
                {{ infos.itensPedido[0].PrazoEntrega }} dias úteis
              </p>
              <hr />
              <small>²Sujeito à aprovação de crédito.</small>
              <small>³Sujeito à disponibilidade de estoque.</small>
            </div>
            <div class="valoresTotais__valores">
              <p>
                <span>Valor dos Produtos:</span>
                {{ infos.vlBruto | toCurrency }}
              </p>
              <p>
                <span>Valor do Desconto:</span>
                {{ infos.vlDesconto | toCurrency }}
              </p>
              <p>
                <span>Valor do Frete:</span>
                {{ infos.vltotalfrete | toCurrency }}
              </p>
              <p>
                <span>Valor Total:</span>
                {{
                  (infos.vlBruto - infos.vlDesconto + infos.vltotalfrete)
                    | toCurrency
                }}
              </p>
            </div>
          </div>

          <div class="garantia">
            <p><span>Prazo de Garantia¹:</span></p>
            <p>
              <span>01 ano total:</span> Agratto, Carrier (Exceto linha Xpower e
              Xperience), Comfee, Consul, Midea (Exceto Linha de Refrigeração),
              Springer, Springer Midea Convencional, TCL e Ventisol
            </p>
            <p><span>01 ano total / 06 anos no compressor:</span> Gree</p>
            <p>
              <span>1 ano total / 10 anos no compressor:</span> LG, Midea (Linha
              de Refrigeração)
            </p>
            <p>
              <span>2 anos total:</span> Springer Midea Inverter e Lorenzetti
              (Somente Aquecedor de 7 Litros)
            </p>
            <p>
              <span>02 anos total / 05 anos no compressor:</span> Daikin (Linha
              Advance) e Fujitsu
            </p>
            <p>
              <span>2 anos total / 10 anos no compressor:</span> Daikin (Linha
              Exclusive)
            </p>
            <p>
              <span>03 anos total:</span> Bosch, Carrier (Somente linha Xpower e
              Xperience), Elgin, Trane e Lorenzetti (Exceto Aquecedor de 7
              Litros)
            </p>
            <small
              >¹Garantia total válida desde que o equipamento seja instalado por
              uma empresa credenciada e operado de acordo com o manual do
              fabricante.</small
            >
          </div>

          <div class="pessoaJuridica">
            <p>
              <span>Imposto:</span> Nas operações interestaduais, o cliente
              (Pessoa Jurídica e contribuinte do ICMS) é responsável por
              observar a sua legislação estadual quanto às despesas com
              recolhimento antecipado do ICMS devido por substituição tributária
              e diferencial de aliquotas.
            </p>
            <p>
              <span
                >Obs.: Não trocamos produtos que já foram instalados ou fora da
                embalagem original.</span
              >
            </p>
          </div>

          <div class="complementaresAssinatura">
            <div class="complementaresAssinatura__nf">
              <p><span>Informações complementares (NF):</span></p>
              <p>{{ infos.observacao }}</p>
            </div>

            <div class="complementaresAssinatura__assinatura">
              <p><span>Assinatura:</span> ________________________________</p>
              <p>
                <span>Nome:</span>
                ________________________________________________
              </p>
              <p><span>CPF/CNPJ:</span> __________________________________</p>
              <p><span>Data:</span> _______ / _______ / ___________</p>
              <small
                >Aprovo o pedido e autorizo o fornecimento dos itens acima
                descriminados, ciente das minhas responsabiidades e condição de
                pagamento.</small
              >
            </div>
          </div>

          <div class="footer">
            <div class="footer__condicoes">
              <p>Condições de Fornecimento:</p>
              <ul>
                <li>
                  Sujeito a confirmação de dados cadastrais por telefone e
                  e-mail para garantir a segurança da compra.
                </li>
                <li>
                  Verifique seu produto no ato do recebimento. Em caso de
                  desacordo ou avaria, recuse a entrega.
                </li>
                <li>
                  Não efetuamos serviços de içamento ou contratação de andaimes.
                  A entrega das mercadorias será no endereço indicado na nota
                  fiscal de venda.
                </li>
                <li>
                  Consulte o manual do fabricante para orientações técnicas e de
                  consumo.
                </li>
                <li>
                  Execute as instalações e manutenções com os técnicos
                  credenciados do fabricante.
                </li>
                <li>
                  Antes de finalizar a compra, consulte a voltagem elétrica do
                  local de instalação do produto.
                </li>
                <li>
                  Em caso de troca ou cancelamento, seguimos o Código de Defesa
                  do consumidor.
                </li>
              </ul>
            </div>

            <div class="footer__reconhecimento">
              <p>Credibilidade e Reconhecimento:</p>
              <img src="../assets/reconhecimentos.png" alt="" />
            </div>
          </div>

          <div class="footerImagem">
            <img src="../assets/footer-leveros.png" alt="" />
          </div>
        </section>
      </vue-html2pdf>
      <button onclick="window.print()">Salvar/Imprimir Pedido</button>
    </div>
  </div>
</template>

<script>
import axios from "axios";
import VueHtml2pdf from "vue-html2pdf";

export default {
  data() {
    return {
      token: null,
      infos: [],
      itensPedido: [],
      isSolar: false,
      loading: true,
      logoPedido: "../assets/logo-leveros.png",
      dataAgendada: false
    };
  },
  methods: {
    generateReport() {
      this.$refs.html2Pdf.generatePdf();
    },
    async getDados() {
      try {
        let dados = JSON.parse(localStorage.getItem("login"));

        if (dados != undefined) {
          this.token = dados.token;
        } else {
          this.token = "";
        }

        var url = new URL(window.location.href);
        var order = url.searchParams.get("Pedido");
        var _token = url.searchParams.get("token");
        if (_token != null) {
          this.token = _token;
        }
        order = window.atob(order);

        try {
          this.loading = true;
          const response = await axios.get(
            `https://www.leverosintegra.com.br/MAP/api/pedido/${order}-token${this.token}`
          );
          this.loading = false;

          this.infos = response.data;
          this.logoPedido = response.data[0].logoPedido;

          this.dataAgendada = !!this.infos[0].transportadora.toLowerCase().includes('agendada')          

          // Valida se é canal Solar
          this.isSolar = this.infos[0].affiliateId
            .toLowerCase()
            .includes("solar");

          if (this.isSolar) {
            this.montaPedidoSolar();
          } else {
            this.montaPedidoRefrigeracao();
          }
        } catch (e) {
          console.log(e);
        }
      } catch (e) {
        console.log(e);
      }
    },

    montaPedidoSolar() {
      console.log("Solar");
    },

    montaPedidoRefrigeracao() {
      let itens = this.infos;

      itens.forEach(function (e) {
        if (e.cjPedido.length != -1) {
          itens = e.cjPedido;
        }
      });
      this.itensPedido = itens;
    },
  },

  components: {
    VueHtml2pdf,
  },

  beforeMount() {
    this.getDados();
  },
  created() {
    this.$forceUpdate();
  }
};
</script>

<style lang="scss" scoped>
.impressao {
  margin: 10px;
}

button {
  background: #005a64;
  color: #fff;
  border-radius: 5px;
  padding: 5px;
  outline: none;
}

.salvarPDF {
  background: #005a64;
  color: #fff;
  border-radius: 5px;
  padding: 5px;
  margin: 10px 0;
}
.header {
  display: flex;
  font-size: 0.688rem;

  &__logo {
    border: 1px solid #005a64;
    margin-right: 10px;
    display: flex;
    justify-content: center;
    align-items: center;
    width: 30%;
  }

  &__pedidoCD {
    display: flex;
    flex-direction: column;
    margin-right: 10px;
    width: 40%;

    &--pedido {
      border: 1px solid #005a64;
      padding: 5px;
      display: flex;
      justify-content: space-between;

      p {
        span {
          font-weight: bold;
        }
      }
    }

    &--cd {
      border: 1px solid #005a64;
      padding: 5px;
      margin-top: 10px;

      p {
        span {
          font-weight: bold;
        }
      }
    }
  }

  &__infosVendedor {
    border: 1px solid #005a64;
    padding: 5px;
    width: 40%;

    p {
      span {
        font-weight: bold;
      }
    }
  }
}

.infosCliente {
  display: flex;
  font-size: 0.8rem;

  &__dadosPessoais {
    border: 1px solid #005a64;
    padding: 5px;
    margin: 10px 10px 10px 0;
    width: 50%;

    p {
      span {
        font-weight: bold;
      }
    }
  }

  &__endereco {
    border: 1px solid #005a64;
    padding: 5px;
    width: 50%;
    margin: 10px 0;

    p {
      span {
        font-weight: bold;
      }
    }

    hr {
      margin: 5px 0;
      color: #b6b6b6;
    }
  }
}

.item {
  font-size: 0.8rem;
  table {
    border-collapse: collapse;
    border-spacing: 0;
    width: 100%;
    border: 1px solid #005a64;

    thead {
      tr {
        th {
          background: #005a64;
          color: #fff;
          padding: 5px;
        }
      }
    }

    tbody {
      tr {
        td {
          padding: 8px 3px;
          text-align: center;
        }
      }
    }
  }
}

.valoresTotais {
  display: flex;
  margin-top: 10px;
  font-size: 0.8rem;

  &__condicoes {
    border: 1px solid #005a64;
    padding: 5px;
    width: 50%;
    margin-right: 10px;
    display: flex;
    flex-direction: column;

    p {
      span {
        font-weight: bold;
      }
    }

    hr {
      margin: 10px 0 5px 0;
    }
  }

  &__valores {
    border: 1px solid #005a64;
    padding: 5px;
    width: 50%;

    p {
      line-height: 1.4;
      span {
        font-weight: bold;
      }
    }
  }
}

.garantia {
  margin-top: 10px;
  border: 1px solid #005a64;
  padding: 10px;
  font-size: 0.7rem;
  padding: 5px;
  width: 100%;
  margin-right: 10px;
  display: flex;
  flex-direction: column;

  p {
    line-height: 1.4;

    &:first-child {
      padding-bottom: 5px;
    }
    span {
      font-weight: bold;
    }
  }

  hr {
    margin: 10px 0 5px 0;
  }
}

.garantiaCli {
  border: 1px solid #005a64;
  padding: 5px;
  width: 50%;
  margin-right: 10px;
  display: flex;
  flex-direction: column;

  p {
    span {
      font-weight: bold;
    }
  }

  hr {
    margin: 10px 0 5px 0;
  }
}

.pessoaJuridica {
  margin-top: 10px;
  border: 1px solid #005a64;
  padding: 10px;
  font-size: 0.8rem;

  p {
    line-height: 1.4;
    padding: 3px 0;
    span {
      font-weight: bold;
    }
  }
}

.complementaresAssinatura {
  display: flex;
  margin-top: 10px;
  font-size: 0.8rem;

  &__nf {
    width: 50%;
    border: 1px solid #005a64;
    padding: 10px;
    margin-right: 10px;

    p {
      line-height: 1.4;
      padding-bottom: 3px;
      span {
        font-weight: bold;
      }
    }
  }

  &__assinatura {
    width: 50%;
    border: 1px solid #005a64;
    padding: 10px;

    p {
      line-height: 1.9;
      span {
        font-weight: bold;
        font-size: 0.813rem;
      }
    }
  }
}

.footer {
  display: flex;
  margin-top: 10px;
  font-size: 0.75rem;

  &__condicoes {
    width: 70%;
    border: 1px solid #005a64;
    padding: 10px;
    margin-right: 10px;

    p {
      font-weight: bold;
      padding-bottom: 10px;
    }

    ul {
      li {
        margin-left: 20px;
        line-height: 1.6;
        font-size: 0.8rem;
      }
    }
  }

  &__reconhecimento {
    width: 30%;
    border: 1px solid #005a64;
    padding: 10px;

    p {
      font-weight: bold;
    }

    img {
      max-width: 100%;
      height: auto;
    }
  }
}

.footerImagem {
  margin-top: 15px;
  img {
    max-width: 100%;
    height: auto;
  }
}

@media print {
  div {
    border: 1px solid rgba(0, 0, 0, 0);
  }
}
</style>